import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { reduxLogout } from '../../redux/reducers/ContrastSlice';
import { logoutFunc } from '../authApiRoutes/APImethods';
import { updateCustomerBootstrapData } from "../../redux/reducers/CustomerBootstrapDataSlice";
import { setCalendarDateRange } from '../../redux/reducers/CalendarRangeSlice';


const cookies = new Cookies();
const useLogOut = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOut = () => {
    dispatch(reduxLogout);
    dispatch(updateCustomerBootstrapData({}));
    dispatch(setCalendarDateRange({}));
    logoutFunc().then((response) => {
      cookies.remove('userEmail', { path: '/' });
      cookies.remove('i18nextLng', { path: '/' });
      localStorage.removeItem('url');
      localStorage.removeItem("announcementSeen");
      navigate('/login');
    }).catch(err=>{
      console.error(err)
    })
  };

  return logOut;
};

export default useLogOut;
